import { useEffect, useState } from 'react';
import { Button, Card, IconButton, Popover, Typography } from '@panviva/panviva-react-ui';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import './gridStyles.scss';

export const DateColumnMenu = (props: any) => {

    const { title, field, firstFilterValue, secondFilterValue, onFilterApply, onClear } = props;

    const [fromDate, setFromDate] = useState(firstFilterValue);
    const [toDate, setToDate] = useState(secondFilterValue);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [open, setOpen] = useState(false);
    const id = open ? 'popper-dropdown' : undefined;

    useEffect(()=>{
        setOpen(Boolean(anchorEl))
    },[anchorEl])

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget?.parentElement);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const getDateWithoutTimeAsGmt = (value: Date, endOfDay: boolean) => {
        const inputDate = value;
        return moment(inputDate).format('YYYY-MM-DDTHH:mm');
    };

    const onFirstFilterChange = (value: any) => {
        const formattedValue = moment(value).format("DD-MM-YYYY hh:mm:ss A");
        setFromDate(formattedValue);
    };

    const onSecondFilterChange = (value: any) => {
        const formattedValue = moment(value).format("DD-MM-YYYY hh:mm:ss A");
        setToDate(formattedValue);
    };

    const onButtonClick = (buttonName: string) => {
        if (buttonName === 'apply' && (fromDate || toDate)) {
            const format_fromDate = getDateWithoutTimeAsGmt(new Date(fromDate), false);
            const format_toDate = getDateWithoutTimeAsGmt(new Date(toDate), true);
            const obj = {...fromDate && {from: {value: format_fromDate, operator: 'ge'}}, ...toDate && {to: {value: format_toDate, operator:'le'}}}
            onFilterApply(field, obj, "eq", true);
        } else {
            onClear(field); setFromDate(null); setToDate(null);
        }
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton icon={(firstFilterValue || secondFilterValue) ? "filter-active" : "filter-inactive"} onClick={handleClick}/>

            <Popover className='margin_left_negative overflow_visible' id={id} open={open} anchorEl={anchorEl} onClose={()=>handleClose()} anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}>
                <Card style={{ display: 'flex' }}>
                    <Typography
                        style={{ marginBottom: '10%', fontWeight: 'bold' }}
                        variant="body_2"
                    >
                        {title}
                    </Typography>
                    <div className='filter-items'>
                    <DatePicker
                            selected={fromDate}
                            showTimeInput
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            timeInputLabel="Time:"
                            dateFormat="dd/MM/YYYY h:mm aa"
                            placeholderText="From Date"
                            maxDate={new Date()}
                            onKeyDown={(e:any) => e.preventDefault()}
                            onSelect={()=>event?.stopPropagation()}
                            onMonthChange={()=>event?.stopPropagation()}
                            onChange={(newValue:any) => onFirstFilterChange(newValue)}/>
                    <DatePicker
                            selected={toDate}
                            showTimeInput
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            timeInputLabel="Time:"
                            dateFormat="dd/MM/YYYY h:mm aa"
                            placeholderText="To Date"
                            maxDate={new Date()}
                            onKeyDown={(e:any) => e.preventDefault()}
                            onSelect={()=>event?.stopPropagation()}
                            onMonthChange={()=>event?.stopPropagation()}
                            onChange={(newValue:any) => onSecondFilterChange(newValue)}/>
                    </div>
                    <div className='filter-button'>                        
                        <Button variant='text' onClick={() => onButtonClick('clear')}>clear</Button>&nbsp;
                        <Button variant='text' onClick={() => onButtonClick('apply')}>apply</Button>
                    </div>
                </Card>
            </Popover>
        </>
    );
};
